import { useState } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import { CompanySelect } from '../../../components/entities/CompanySelect'
import React from 'react'
import { CompanyEntity } from 'types/CompanyEntity'

export const ConnectCompanyDialog = ({
    open,
    setOpen,
    pathToConnect,
    onConnectCompany,
    onCancel,
}: {
    open: boolean
    setOpen: (v: boolean) => void
    pathToConnect: string
    onConnectCompany: (path: string, company: Pick<CompanyEntity, 'id' | 'name'>) => Promise<void>
    onCancel: () => void
}) => {
    const [selectedCompany, setSelectedCompany] = useState<Pick<CompanyEntity, 'id' | 'name'> | null>(null)
    const onClose = () => {
        setOpen(false)
        if (onCancel) onCancel()
    }
    const onConnect = () => {
        if (!selectedCompany) return

        void onConnectCompany(pathToConnect, selectedCompany)
        setOpen(false)
    }

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Anslut bolag</DialogTitle>
            <DialogContent>
                <DialogContentText>Välj bolag att koppla till "{pathToConnect}".</DialogContentText>
                <CompanySelect onSelectCompany={setSelectedCompany} />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Avbryt</Button>
                <Button onClick={onConnect}>Koppla</Button>
            </DialogActions>
        </Dialog>
    )
}
